import React, { useState } from "react";
import { Formik } from "formik";
import {
  Button,
  ButtonSet,
  Form,
  FormGroup,
  RadioButtonGroup,
  RadioButton,
} from "carbon-components-react";

import { makeEvent } from "web_modules/shared/FormHelpers/carbon-helpers";

import { getVALoanFormLabelFromKey } from "../../data-helpers";
import { validationSchema } from "./form-values";

const styles = require("../form.module.scss");

interface Props {
  initialValues: any;
  hasCoborrower: boolean;
  onSubmit: (values) => void;
}

const GeneralVAForm: React.FC<Props> = ({ onSubmit, hasCoborrower, initialValues }: Props) => {
  const [editing, setEditing] = useState(false);

  return (
    <Formik
      enableReinitialize
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={validationSchema}
      className={styles.form}
    >
      {({ dirty, handleBlur, handleChange, handleSubmit, resetForm, values }) => {
        const allFields = [
          "borrower1_is_veteran",
          "borrower2_is_veteran",
          "borrower1_use_va_entitlement",
          "borrower2_use_va_entitlement",
          "is_va_loan_application_borrower_value",
        ];

        return (
          <Form
            onSubmit={e => {
              e.preventDefault();
              handleSubmit();
            }}
            className={styles.form}
          >
            <div className={styles.buttonContainer}>
              {!editing ? (
                <Button kind="secondary" size="sm" onClick={() => setEditing(true)}>
                  Edit
                </Button>
              ) : (
                <ButtonSet>
                  <Button
                    kind="tertiary"
                    size="sm"
                    onClick={() => {
                      setEditing(false);
                      resetForm();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button disabled={!dirty} kind="primary" size="sm" type="submit">
                    Save
                  </Button>
                </ButtonSet>
              )}
              <div style={{ marginBottom: "20px" }} />
            </div>
            <FormGroup legendText="Application Info" className={styles.formInput}>
              {allFields.map((key: string) => {
                const value = values[key];
                const disableB2FieldsForSingleBorrowerLoans =
                  ["borrower2_is_veteran", "borrower2_use_va_entitlement"].includes(key) &&
                  !hasCoborrower;

                return (
                  <RadioButtonGroup
                    key={key}
                    id={key}
                    name={key}
                    disabled={!editing || disableB2FieldsForSingleBorrowerLoans}
                    legendText={getVALoanFormLabelFromKey(key)}
                    valueSelected={value ? "true" : "false"}
                    onChange={value => {
                      // RadioButtonGroup's `valueSelected` prop doesn't work correctly when using true booleans, so use stringified bools for now
                      const val = value === "true";
                      const e = makeEvent(key, val);
                      handleChange(e);
                      handleBlur(e);
                    }}
                  >
                    <RadioButton value="true" labelText="Yes" id={`${key}-yes`} />
                    <RadioButton value="false" labelText="No" id={`${key}-no`} />
                  </RadioButtonGroup>
                );
              })}
            </FormGroup>
          </Form>
        );
      }}
    </Formik>
  );
};

export default GeneralVAForm;
